export const CAT_SEARCH = 'CAT_SEARCH';
export const SET_PAGE = 'SET_PAGE';
